// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement } from 'react';

const TitleField = (): ReactElement => {
    const i = useLocalMessage();

    return (
        <THForm.Item
            name="title"
            label={i('app.dashboard.widget.create.form.title.label')}
            rules={[{ required: true, message: i('app.dashboard.widget.create.form.title.required') }]}
        >
            <THInput placeholder={i('app.dashboard.widget.create.form.title.placeholder')} />
        </THForm.Item>
    );
};

export default TitleField;
